import React from 'react';
import Appbar from 'components/appbar/Appbar';
import UserListTable from './list/table/UserListTable';
import UserListModule from './list/module/UserListModule';
import UserAction from './UserAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import PaginationProvider from 'hooks/pagination';
import Pagination from 'components/pagination/Pagination';
import UsersFilterBox from './UsersFilterBox';
import { useFetchUsers } from './hooks/useFetchUsers';
import { useDisplayMode } from 'hooks/useDisplayMode';
import NoData from 'components/no-data/NoData';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';

const Users: React.FC = () => {
  const {
    users,
    filter,
    loading,
    orderedIndex,
    handleSearch,
    handleSort,
    handleChange,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchUsers();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Usuários" ActionsComponent={<UserAction />} />
      <PageHeaderActions
        title="Usuários"
        description="Gestão de usuários do sistema"
        ActionComponent={<NewRecordButton label="Novo usuário" to="/users/new" />}
      />

      <UsersFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : users.length === 0 ? (
          <NoData message="Nenhum usuário encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? <UserListTable users={users} /> : <UserListModule users={users} />}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Users;
